import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFormatUnderlineComponent } from "./med-icon-format-underline.component";

@NgModule({
  declarations: [
    MedIconFormatUnderlineComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFormatUnderlineComponent,
  ],
})
export class MedIconFormatUnderlineModule { }
